import React from "react";
import PropTypes from "prop-types";
import { Card, Typography } from "antd";

const { Text, Paragraph } = Typography;

const CategoryOption = ({ icon, title, subtitle }) => (
  <Card
    style={{
      background: "transparent",
      borderRadius: 8,
      textAlign: "center",
      border: "none",
      transition: "transform 0.2s",
    }}
  >
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: "auto",
        paddingTop: 2,
      }}
    >
      <div style={{ fontSize: 24, marginBottom: 8 }}>{icon}</div>

      <Text strong style={{ fontSize: 16 }}>
        {title}
      </Text>

      <Paragraph
        type="secondary"
        style={{
          marginTop: 4,
          fontSize: 12,
          whiteSpace: "pre-line",
          maxWidth: 250,
          wordBreak: "break-word",
          textAlign: "center",
        }}
      >
        {subtitle}
      </Paragraph>
    </div>
  </Card>
);

CategoryOption.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};

export default CategoryOption;
